export default __webpack_public_path__ + "static/media/ref-kwp-wroclaw.d4836127.pdf";